import { useTranslation } from 'react-i18next';
import {
  Drawer,
  DrawerHeader,
  DrawerBody,
  DrawerFooter
} from '@cat-ecom/pcc-components';
import { CatButton } from '@blocks-react/components/Button';
import { CatIconArrowBack } from '@blocks-react/components/Icons/ArrowBack';
import { CatIconClose } from '@blocks-react/components/Icons/Close';
import AddressFormFields from '../../Blocks/AddressFormFields';
import PropTypes from 'prop-types';
import styles from './AddAddressMobileDrawer.module.scss';
import cx from 'classnames';

const AddAddressDrawer = ({
  showAddressLine2,
  countries,
  addressLimit,
  requiredFields,
  selectedCountry,
  showPhoneNumberWithVerification,
  showNeighborhood,
  isDealerUser,
  profileAddressId,
  setReturnToEdit,
  withDropdownSearch,
  onSubmit,
  ...AddAddressDrawerProps
}) => {
  const [t] = useTranslation();

  return (
    <Drawer {...AddAddressDrawerProps} hideCloseButton>
      <DrawerHeader className="w-100">
        <div className="d-flex justify-content-between">
          <div className="d-flex align-items-center">
            <CatButton
              hideText
              variant="ghost"
              className="me-3"
              data-testid="go-back-button"
              size="sm"
              onClick={AddAddressDrawerProps.returnToEdit}
            >
              <CatIconArrowBack slot="before" />
            </CatButton>
            <h4
              className={cx(
                'cat-u-theme-typography-title m-0',
                styles['add-address-mobile__title']
              )}
            >
              {t('ADD_A_NEW_ADDRESS')}
            </h4>
          </div>
          <CatButton
            hideText
            variant="ghost"
            className="p-1"
            data-testid="close-button"
            size="sm"
            onClick={AddAddressDrawerProps.closeDrawer}
          >
            <CatIconClose slot="before" />
          </CatButton>
        </div>
      </DrawerHeader>
      <DrawerBody>
        <AddressFormFields
          isAddressNameEditable
          showAddressLine2={showAddressLine2}
          showEmail
          showName
          showPhoneNumber
          countryData={countries}
          addressLimit={addressLimit}
          requiredFields={requiredFields}
          selectedCountry={selectedCountry}
          showPhoneNumberWithVerification={showPhoneNumberWithVerification}
          showNeighborhood={showNeighborhood}
          isDealerUser={isDealerUser}
          profileAddressId={profileAddressId}
          showAddressName
          autoCompleteOnZipcode
          withDropdownSearch={withDropdownSearch}
        />
      </DrawerBody>
      <DrawerFooter className="d-flex gap-3">
        <CatButton variant="primary" fullwidth onClick={onSubmit}>
          {t('SAVE')}
        </CatButton>
        <CatButton
          variant="ghost"
          fullwidth
          onClick={AddAddressDrawerProps.closeDrawer}
        >
          {t('CANCEL')}
        </CatButton>
      </DrawerFooter>
    </Drawer>
  );
};

AddAddressDrawer.propTypes = {
  addressLimit: PropTypes.string,
  countries: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string,
      displayName: PropTypes.string,
      states: PropTypes.arrayOf(
        PropTypes.shape({
          code: PropTypes.string,
          displayName: PropTypes.string
        })
      )
    })
  ),
  selectedCountry: PropTypes.string,
  requiredFields: PropTypes.arrayOf(PropTypes.string),
  showPhoneNumberWithVerification: PropTypes.bool,
  showNeighborhood: PropTypes.bool,
  isDealerUser: PropTypes.bool,
  profileAddressId: PropTypes.string,
  showAddressLine2: PropTypes.bool,
  setReturnToEdit: PropTypes.func,
  withDropdownSearch: PropTypes.bool,
  onSubmit: PropTypes.func
};

export default AddAddressDrawer;
